export default class Tag {
	public tagId: string;
	public tagText: Map<string, string>;
}
